// This is generated.  Alter it in blockGroups/formElements/types/ReadOnlyFormList.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      selectionProperty,
      selectionKeys = [],
    } = hNode;

    // This block tells us nothing about namespaces/relations, but maybe the children do?
    let [subDataDictionary = {}, _partialTypeDefinition = {}] =
      hNode.children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, context);
          return [
            merge(sdd, _subDataDictionary),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
              context,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    // Build the array schema with object items containing the child properties
    const itemSchema = Type.Object(_partialTypeDefinition, {
      title: 'Item',
      'x-dataType': 'object',
      additionalProperties: true,
    });

    const arraySchema = Type.Optional(
      Type.Array(itemSchema, {
        title: title,
        'x-id': id,
        'x-dataType': 'array',
        'x-propertyName': propertyName,
        'x-required': false,
        'x-optional': true,
        readOnly: true,
      }),
    );

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: arraySchema,
    };

    if (selectionProperty) {
      // The displayed rows stay read-only; checkboxes save to a separate writable
      // field on the same form. With selectionKeys, save only identifiers such as
      // database and migrationFile, so display fields do not become execution input.
      // Without selectionKeys, the selection contains the complete rows.
      partialTypeDefinition[selectionProperty] = Type.Optional(
        Type.Array(
          selectionKeys.length
            ? Type.Object(
                Object.fromEntries(
                  selectionKeys.map((key) => [key, Type.String()]),
                ),
              )
            : itemSchema,
          {
            'x-dataType': 'array',
            'x-propertyName': selectionProperty,
          },
        ),
      );
    }
    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'ReadOnlyFormList',
  module.exports,
);
